import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UAVFlyPath } from '@6grain/masofa-monolith-api-client/uav/model/uAVFlyPath';
import { environment } from '@root/src/environments/environment';

interface GalleryPhoto {
  id: string;
  fileStorageId: string;
  title?: string;
  createAt?: string;
}

@Component({
  selector: 'app-uav-gallery-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './uav-gallery-modal.component.html',
  styleUrls: ['./uav-gallery-modal.component.scss'],
})
export class UavGalleryModalComponent implements OnChanges {
  @Input() isVisible: boolean = false;
  @Input() survey: UAVFlyPath | null = null;
  @Output() close = new EventEmitter<void>();

  private translate = inject(TranslateService);

  photos: GalleryPhoto[] = [];
  selectedPhotoIndex: number = -1;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['survey'] && this.survey) {
      this.extractPhotos();
    }
  }

  private extractPhotos(): void {
    this.photos = [];
    if (!this.survey) return;

    const collections =
      (this.survey as any).uavPhotoCollections ||
      (this.survey as any).collections ||
      [];
    collections.forEach((col: any) => {
      if (col.previewFileStorageId) {
        const colPhotos = col.uavPhotos || col.photos || [];
        const mainPhoto = colPhotos.length > 0 ? colPhotos[0] : null;
        this.photos.push({
          id: col.id,
          fileStorageId: col.previewFileStorageId,
          title: mainPhoto ? mainPhoto.title : this.translate.instant('Photo'),
          createAt: mainPhoto ? mainPhoto.originalDate : col.createAt,
        });
      }
    });
  }

  getImageUrl(fileStorageId: string): string {
    return `${environment.api}/uav/UavPhoto/GetImage/${fileStorageId}`;
  }

  onClose(): void {
    this.isVisible = false;
    this.selectedPhotoIndex = -1;
    this.close.emit();
  }

  openFullScreen(index: number): void {
    this.selectedPhotoIndex = index;
  }

  closeFullScreen(): void {
    this.selectedPhotoIndex = -1;
  }

  nextPhoto(event: Event): void {
    event.stopPropagation();
    if (this.selectedPhotoIndex < this.photos.length - 1) {
      this.selectedPhotoIndex++;
    }
  }

  prevPhoto(event: Event): void {
    event.stopPropagation();
    if (this.selectedPhotoIndex > 0) {
      this.selectedPhotoIndex--;
    }
  }
}
